<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="kids" />
      </div>

      <div class="left" style="margin:0px 0 0 27px;">
        <img src="/assets/images/titles/menu_left_kids.png" />
      </div>

      <br clear="all" />
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/kids.png">
      </div>
      <br clear="all">

      <div class="product-container">
        <div class="product-description" style="margin:0px 0 10px 0px; width:250px;">
          <span style="color:#F00; font-weight:bold;">Kids meal</span>
          includes a choice of Fries, Chips or Apple Slices and a small drink.
        </div>

        <ProductList :products="products" />

        <br clear="all" />

        <div class="left" style="margin:20px 0 0 -90px;">
          <img src="/assets/images/menu_img/menu_kids_bottom.png">
        </div>
      </div>

      <div class="menu_right">
        <div class="right" style="margin:-116px 14px 0 0;">
          <img src="/assets/images/menu_img/menu_kids_side.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Kids',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'HAMBURGER',
          description: '1/4 lbs. fresh ground Black Angus Chuck',
          modifiers: [],
        },
        {
          id: 2,
          name: 'CHICKEN TENDERS',
          description: 'with Ranch or BBQ sauce',
          modifiers: [],
        },
        {
          id: 4,
          name: 'GRILLED CHEESE',
          description: 'Traditionally served with American Cheese',
          modifiers: [],
        },
        {
          id: 5,
          name: 'HOT DOG',
          description: 'Old fashioned 100% all beef frankfurter',
          modifiers: [],
        },
        {
          id: 6,
          name: 'KIDS SHAKE',
          description: '',
          modifiers: [
            {
              description: 'Vanilla, Strawberry, Chocolate',
            },
            {
              description: 'Oreo, Green Mint Chocolate Chip',
            },
          ],
        },
      ],
    };
  },
};
</script>
